import { t } from 'i18next';
import { ReactElement } from 'react';
import { Trans } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import CompassIcon from '../../../Shared/Icons/CompassIcon';
import NavSidebarSection from '../NavSidebarSection';
import { SidebarProps } from './SidebarProps';

const ExploreSidebarSection = (props: SidebarProps): ReactElement => {
  const { onNavClick } = props;

  /*   const canViewHearings = (): Thunk<boolean> => {
    return dispatch(
      checkPermission(abilityGlossary.VIEW, abilityGlossary.HEARINGS, true),
    );
  }; */

  /*   const canViewLegislators = (): Thunk<boolean> => {
    return dispatch(
      checkPermission(abilityGlossary.VIEW, abilityGlossary.HEARINGS, true),
    );
  };
 */
  const getCardBody = (): ReactElement => {
    return (
      <>
        <NavLink
          activeClassName="active-nav-link"
          onClick={onNavClick}
          to="/jurisdictions"
        >
          <h4 className="sub-item">Overview</h4>
        </NavLink>
        <NavLink
          activeClassName="active-nav-link"
          id="universal-hearings-link"
          onClick={onNavClick}
          to="/hearings"
        >
          <h4 className="sub-item">Hearings</h4>
        </NavLink>
        <NavLink
          activeClassName="active-nav-link"
          id="universal-legislators-link"
          onClick={onNavClick}
          to="/legislators"
        >
          <h4 className="sub-item">Legislators</h4>
        </NavLink>
      </>
    );
  };

  return (
    <NavSidebarSection
      cardBody={getCardBody()}
      customGateTooltipContent={
        <Trans
          components={{
            exploreLink: <a href={t('urls.legislatorDetails')} target="_blank" />,
            gate: <p className="tooltip-header" />,
          }}
          i18nKey="featureGating.tooltipText.exploreSidebar"
          key="featureGating.tooltipText.exploreSidebar"
        />
      }
      eventKey="EXPLORE"
      header="Legislative Resource Center"
      icon={<CompassIcon />}
    />
  );
};

export default ExploreSidebarSection;
